var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found d-flex center"},[_c('el-empty',{attrs:{"image-size":300,"description":" "}},[_c('p',{staticClass:"tip"},[_vm._v("该页面无法访问或不存在")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }